import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateArApOFfSetsDto } from "../../../dtos/documents/ArApOffsets/CreateArApOffsetsDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ArapOffsetsDetail } from "../../../components/Pages/Documents/ArApOffsets/ArApOffsetsDetail";
import { ArapOffsetsService } from "../../../services/documents/ArapOffsetsService";
import { NFLookupArApOffsets } from "../../../components/Shared/NewForms/NFLookupArApOffsets";
import ArApOffsetsList from "../../../components/Pages/Documents/ArApOffsets/ArApOffsetsList";

export const ArApOffsets: IAppEntity = {
  entityType: "document",
  title: "ArAp Offsets",
  pluralTitle: "Arap Off Sets",
  apiUrl: "ArApOffsets",
  apiEnum: ReferenceTypes.DocumentArApOffset,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ArapOffsetsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ArApOffsetsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupArApOffsets, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ArapOffsetsService("ArApOffsets"),
  getEmptyModel: () => {
    const model: CreateArApOFfSetsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      status: 0,
      
      createdDate: new Date(),
    };
    return model;
  },
};
